import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, ImageAvatar, SquareChip, TagsArray, Text, useSettings } from 'app/main/components';
import { DateRangeSquareChip } from 'app/main/components/list-items';
import buttons from './CommercialCampaignsButtons';

export default function CommercialCampaignsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.cmcp_user_assigned_uid}
			avatar={props.model.user_assigned_avatar}
			initials={props.model.cmcp_title_initials}
			labelBadge={props.model.cmst_title_initials}
			labelBadgeTooltip={props.model.cmst_title}
			badgeColor={props.model.cmst_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 600 ? 8 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.cmcp_warning_desc && (
								<Tooltip title={props.model.cmcp_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.cmcp_blocked_desc && (
								<Tooltip title={props.model.cmcp_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'commercialcampaigns', uid: props.model.cmcp_uid }}
							>
								{props.model.cmcp_title}
							</Text>
						</Grid>
						{/* TYPE */}
						<Grid>
							{props.model.cmty_title && (
								<SquareChip label={props.model.cmty_title} backgroundColor={props.model.cmty_color} />
							)}
						</Grid>
						{/* DATE FROM - TO */}
						<Grid>
							<DateRangeSquareChip from={props.model.cmcp_d_from} to={props.model.cmcp_d_to} />
						</Grid>
						{/* TAGS */}
						<Grid>
							<TagsArray tags={props.model.cmcp_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={4}>
						<Grid container>
							{/* INTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.cmcp_user_assigned_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_INTUSER')}
								>
									{props.model.user_assigned_title}
								</ButtonLink>
							</Grid>
							{/* EXTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.cmcp_user_assigned_2_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_EXTUSER')}
								>
									{props.model.user_assigned_2_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
